module.exports = __webpack_public_path__ + "static/media/homepage_atf_3_mo.10354cd2.png";